import React from 'react';
import { View, Text } from 'react-native';
import DLOModal from '../../DLOModal';
import DLOButton from '../../DLOButton';
import { styles } from './styles';

interface SaveResultModalProps {
  visible: boolean;
  saveModalType: 'success' | 'error';
  saveModalMessage: string;
  onClose: () => void;
}

const SaveResultModal: React.FC<SaveResultModalProps> = ({
  visible,
  saveModalType,
  saveModalMessage,
  onClose,
}) => {
  return (
    <DLOModal
      visible={visible}
      onClose={onClose}
      title={saveModalType === 'success' ? 'Success' : 'Error'}
      width={400}
      showCloseIcon={false}
      hideButtons={true}
    >
      <View style={styles.modalContent}>
        <Text style={styles.zoneItemText}>
          {saveModalMessage}
        </Text>
        <View style={styles.modalButtonContainer}>
          <DLOButton
            text="OK"
            variant="primary"
            size="medium"
            onPress={onClose}
            style={styles.modalOkButton}
          />
        </View>
      </View>
    </DLOModal>
  );
};

export default SaveResultModal;